// Copyright (C) 2018-2026 Skylark Drones

import {
  getLatestRelease,
  normalizeRelease,
  releaseProduct
} from '@/services/ReleaseService'

export default {
  setUserResponse({ commit }, payload) {
    commit('updateUser', payload)
  },

  setPreferences({ commit }, preferences) {
    commit('updateFilters', preferences.filters)
    commit('setGroupByType', preferences.group)
    commit('setViewMode', preferences.view)
  },
  updateFCL({ commit, getters }, { featureKey, payload }) {
    const companyIndex = getters.currentActiveOrganization._index
    const featureIndex = getters.activeFCL[featureKey]._index
    commit('updateFCL', { featureIndex, companyIndex, payload })
  },
  async fetchLatestReleaseChangelog({ commit }) {
    commit('setIsFetchingLatestReleaseChangelog', true)

    try {
      const resp = await getLatestRelease({ product: releaseProduct.DMO_WEB })
      commit('setLatestReleaseChangelog', normalizeRelease(resp.data))
    } finally {
      commit('setIsFetchingLatestReleaseChangelog', false)
    }
  }
}
